import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { createInitialLabBrokerState, LabBrokerState } from './lab-broker.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'lab-broker', resettable: true })
export class LabBrokerStore extends Store<LabBrokerState> {
	constructor() {
		super(createInitialLabBrokerState());
	}
}
